import * as Phaser from "phaser";
import { CommonVarsGlobalPlugin } from "$/game/plugins/CommonVarsGlobalPlugin.ts";
import { KeysManagerGlobalPlugin } from "$/game/plugins/KeysManagerGlobalPlugin.ts";
import { TelegramGlobalPlugin } from "$/game/plugins/TelegramGlobalPlugin.ts";
import { SettingsGlobalPlugin } from "$/game/plugins/SettingsGlobalPlugin.ts";
import { ApiGlobalPlugin } from "$/game/plugins/ApiGlobalPlugin.ts";

export type BasicOverlayData = {
  fromScene?: string;
  showCloseButton?: boolean;
};

export class BasicOverlay extends Phaser.Scene {
  public global!: CommonVarsGlobalPlugin;
  public keys!: KeysManagerGlobalPlugin;
  public telegram!: TelegramGlobalPlugin;
  public settings!: SettingsGlobalPlugin;
  public api!: ApiGlobalPlugin;
  private overlayData: BasicOverlayData = {
    fromScene: undefined,
    showCloseButton: false,
  };

  constructor(
    keyOrConfig: string | Phaser.Types.Scenes.SettingsConfig = {
      key: "BasicOverlay",
    },
  ) {
    if (typeof keyOrConfig === "string") {
      super({ key: keyOrConfig });
    } else {
      super(keyOrConfig);
    }
  }

  init() {
    this.global = this.plugins.get("globalVars") as CommonVarsGlobalPlugin;
    this.keys = this.plugins.get("keysManager") as KeysManagerGlobalPlugin;
    this.telegram = this.plugins.get("telegram") as TelegramGlobalPlugin;
    this.settings = this.plugins.get("settings") as SettingsGlobalPlugin;
    this.api = this.plugins.get("api") as ApiGlobalPlugin;
  }

  get atlas(): string {
    return this.keys?.atlases?.main?.key ?? "main";
  }

  create(data: BasicOverlayData) {
    this.overlayData = data;
    this.add.rectangle(
      0,
      0,
      this.scale.width,
      this.scale.height,
      this.global.TUNER_TWA_CONFIG.palette.background,
      0.8,
    )
      .setOrigin(0, 0)
      .setInteractive();
    // .setDepth(1000);

    if (data.showCloseButton) {
      const closeButton = this.add.text(
        this.cameras.main.width - 100,
        60,
        "✖",
        {
          fontSize: "80px",
          color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
          fontStyle: "bold",
          fontFamily: "Phantom-Muff",
        },
      )
        .setOrigin(0.5)
        .setInteractive()
        .on("pointerdown", () => {
          if (this.settings.getSetting("isVibrationEnabled")) {
            this.telegram.twaSDK.hapticFeedback.impactOccurred("medium");
          }
          this.close();
        })
        .on("pointerover", () => {
          this.tweens.killTweensOf(closeButton);
          this.tweens.add({
            targets: closeButton,
            scaleX: 1.08,
            scaleY: 1.08,
            angle: Math.random() * 5 - 2.5,
            duration: 200,
            ease: "Power2",
          });
        })
        .on("pointerout", () => {
          this.tweens.killTweensOf(closeButton);
          this.tweens.add({
            targets: closeButton,
            scaleX: 1,
            scaleY: 1,
            angle: 0,
            duration: 200,
            ease: "Power2",
          });
        });
    }

    this.time.delayedCall(0, () => {
      this.animateShow();
    });
  }

  // beforeUpdate(time: number, delta: number) {
  //   this.animateShow();
  // }

  close() {
    this.scene.stop(this.scene.key);
    if (this.overlayData.fromScene) {
      this.scene.resume(this.overlayData.fromScene);
    }
  }

  animateShow() {
    // тут надо добавить заливку поверх всего экрана
    const fillOverlay = this.add.rectangle(
      0,
      0,
      this.cameras.main.width,
      this.cameras.main.height,
      this.global.TUNER_TWA_CONFIG.palette.background,
      1,
    )
      .setOrigin(0, 0)
      .setInteractive()
      .setDepth(1000);

    this.tweens.add({
      targets: fillOverlay,
      alpha: 0,
      duration: 500,
      ease: "Power2",
      onComplete: () => {
        fillOverlay.destroy();
      },
    });
  }
}
